module.exports = __webpack_public_path__ + "assets/img/news1.4.42c66f7f.png";